module.exports = __webpack_public_path__ + "img/UTBEAR-6.3e872a6a.jpg";